export default "/blogdoamigo/_next/static/images/doctum-logo-ffd27fc65b52602c8cb0ee0a1f04fa4e.webp";